module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label-tag', {
    attrs: {
      "tagArray": [((_vm.$t('conversation_edit')) + "(" + _vm.tagName + ")")]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-5",
    staticStyle: {
      "overflow": "auto",
      "min-height": "50vh"
    }
  }, [_c('table', {
    staticClass: "table table-borderless table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('selected_character')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dialogue')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.dialogsInfo) ? _c('tbody', {
    staticStyle: {
      "border-top": "1px #cccccc solid",
      "border-bottom": "1px #cccccc solid"
    }
  }, _vm._l((_vm.dialogsInfo.sentences), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('toggle-button', {
      attrs: {
        "sync": true,
        "labels": {
          checked: _vm.locale === 'tw' ? '主角' : 'Avatar',
          unchecked: _vm.locale === 'tw' ? _vm.dialogsInfo.roleName : _vm.dialogsInfo.roleNameEn
        },
        "color": {
          checked: '#5dceb0',
          unchecked: '#6e817f'
        },
        "width": 140
      },
      model: {
        value: (item.isPlayer),
        callback: function($$v) {
          _vm.$set(item, "isPlayer", $$v)
        },
        expression: "item.isPlayer"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "d-flex",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "onkeyup": "value=value.replace(/[^a-zA-Z\\.\\?\\,\\!\\;\\ \\/]/ig,'')",
        "placeholder": _vm.$t('symbols_rules'),
        "maxlength": "100",
        "type": "text"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "px-2"
    }, [_vm._v(_vm._s(item.text.length) + "/100")]), _vm._v(" "), _c('div', {
      staticClass: "pointer control-btn px-2",
      on: {
        "click": _vm.removeContent
      }
    }, [_vm._v(_vm._s(_vm.$t('delete')))])])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addSentences
    }
  }, [_vm._v(_vm._s(_vm.$t('add')))])])]), _vm._v(" "), _c('div', {
    staticClass: "mx-5",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editContent
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6012c5ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/vr/ConversationEdit.vue
// module id = 789
// module chunks = 3